module.exports = __webpack_public_path__ + "static/img/SM.d59e4867.svg";